import { intl } from 'lang/intl'
import React, { type CSSProperties } from 'react'
import { FormattedDate, FormattedDateTimeRange } from 'react-intl'

import AspectContainer from '../../../../../../components/AspectContainer/AspectContainer'
import { useWebinarColors } from '../../../../../../hooks/useWebinarColors'
import { WebinarPanelComponent } from '../../../index'

import LiveNow from './LiveNow'

import './SessionCard.scss'

interface SessionCardProp {
  title: string
  thumbnailUrl: string
  linkUrl: string
  startDate: Date
  endDate?: Date
  names?: Array<string>
  isLive?: boolean
  state?: string
}

const SessionCard = ({
  title,
  thumbnailUrl,
  linkUrl,
  startDate,
  endDate,
  names = [],
  isLive = false,
  state,
}: SessionCardProp) => {
  const webinarColors = useWebinarColors()

  return (
    <WebinarPanelComponent className="session-card">
      <div className="content-enclosure">
        <div className="header">{title}</div>
        <div className="labels-thumbnail-enclosure">
          <div className="labels">
            <div className="date">
              {isLive ? (
                <LiveNow />
              ) : (
                <>
                  <FormattedDate
                    value={startDate}
                    weekday="long"
                    month="short"
                    day="numeric"
                  />
                  {endDate && state !== 'On Demand' && state !== 'Past' && (
                    <>
                      {' '}
                      <FormattedDateTimeRange
                        from={startDate}
                        to={endDate}
                        hour12={false}
                        hour="2-digit"
                        minute="2-digit"
                      />
                    </>
                  )}
                </>
              )}
            </div>
            <div className="speakers">{names.join(' · ')}</div>
          </div>
          <div className="thumbnail">
            <AspectContainer>
              <img
                src={thumbnailUrl}
                alt={intl.formatMessage({
                  defaultMessage: 'Thumbnail for session',
                })}
              />
            </AspectContainer>
          </div>
        </div>
      </div>
      {state !== 'Past' && (
        <div className="footer">
          <a
            href={linkUrl}
            className={
              isLive ? 'primary-session-button' : 'secondary-session-button'
            }
            style={
              {
                '--secondary-background':
                  webinarColors.tabs.contrast.transparent('50%'),
                '--secondary-text': webinarColors.tabs.contrast.contrast.color,
              } as CSSProperties
            }
          >
            {state !== 'Upcoming'
              ? intl.formatMessage({ defaultMessage: 'Watch' })
              : intl.formatMessage({ defaultMessage: 'Show' })}
          </a>
        </div>
      )}
    </WebinarPanelComponent>
  )
}

export { SessionCard }
